import { TranslateResult } from 'vue-i18n';
import { Contact } from '@/types';

export class SearchContacts {
  protected static CACHE_DELIMITER = ';';
  protected static cache: { [contactId: string]: string; } = {};
  /** Can be replaced with $t */
  public static translate: (key: string) => TranslateResult = () => 'Visitor';

  public static searchContactsByText(args: {
    contacts?: Contact[];
    searchText?: string;
  }): Contact[] {
    const { contacts = [] } = args;
    const searchText = (args.searchText || '').trim();

    return searchText
      ? contacts.filter(contact => this.hasText({ contact, searchText }))
      : contacts;
  }

  /** Cache should be cleared when contact is modified */
  public static clearCacheByContactIds(contactIds: string[]) {
    for (const contactId of contactIds) {
      delete this.cache[contactId];
    }
  }

  protected static hasText(args: { contact: Contact; searchText: string; }) {
    const { contact, searchText } = args;

    if (!searchText) {
      return true;
    }

    if (!this.cache[contact.contactId]) {
      const { name, firstName, lastName, emails, phoneNumbers } = contact;

      this.cache[contact.contactId] = [
        name,
        firstName,
        lastName,
        emails.join(this.CACHE_DELIMITER),
        phoneNumbers.join(this.CACHE_DELIMITER),
      ].join(this.CACHE_DELIMITER);
    }

    return this.cache[contact.contactId].toLowerCase().includes(searchText.toLowerCase());
  }
}
